import { Alert, Button, Space } from 'antd';
import { connect } from 'react-redux';
import { fetchMainPageOptions } from '../../actions/previewSideBar';
import React, { useContext, useMemo } from 'react';
import { find } from 'underscore';
import { isSectionChanged } from '../../../../functions/isDeepEqual';
import { Context } from 'app/index';
import { useDesktop } from 'app/hooks/useDesktop';
import { InfoCircleOutlined } from '@ant-design/icons';

export const SnapshotAlert = ({ isAdmin, onSave }) => {
    const {
        settings: {
            lendingSections: { snapshot, settings, setSettings },
        },
        showColumns: {
            showColumns: { setShowColumns },
        },
    } = useContext(Context);
    const isDesktop = useDesktop();
    const show = useMemo(() => {
        if (settings.length !== snapshot.length) return true;
        return settings?.some((section, sectionIndex) => {
            let snapshotIndex = -1;
            const sectionSnapshot = find(snapshot, (item, index) => {
                const equal = item.id === section.id;
                if (equal) {
                    snapshotIndex = index;
                }
                return equal;
            });
            return isSectionChanged(
                section,
                sectionSnapshot,
                sectionIndex,
                snapshotIndex
            );
        });
    }, [settings, snapshot]);
    function onDiscard() {
        setSettings((prevState) => ({
            ...prevState,
            settings: prevState.snapshot,
        }));
        setShowColumns(false);
    }
    function onSaveValid() {
        setSettings((prevState) => ({
            ...prevState,
            snapshot: prevState.settings,
        }));
    }
    if (!show || !isAdmin) return null;
    return (
        <div className="alert">
            <Alert
                style={{
                    top: `${
                        isDesktop ? 'calc(100vh - 80px)' : 'calc(100vh - 130px)'
                    }`,
                    display: 'flex',
                    flexDirection: 'column',
                }}
                className={'snapshot-alert'}
                message={
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        <InfoCircleOutlined style={{ marginRight: '8px' }} />
                        Есть несохраненные изменения
                    </div>
                }
                type="info"
                closable={false}
                // showIcon
                action={
                    <Space>
                        <Button
                            onClick={() => onSave(settings, onSaveValid)}
                            size="small"
                            type="primary"
                        >
                            Сохранить
                        </Button>
                        <Button
                            onClick={onDiscard}
                            size="small"
                            danger
                            type="danger"
                        >
                            Сбросить
                        </Button>
                    </Space>
                }
            />
        </div>
    );
};

const mapStateToProps = (state) => ({
    isAdmin: state.authState.user?.isAdmin,
});

const mapDispatchToProps = (dispatch) => {
    return {
        onSave: (data, success) =>
            dispatch(fetchMainPageOptions(data, success)),
    };
};

export const ConnectedSnapshotAlert = connect(
    mapStateToProps,
    mapDispatchToProps
)(SnapshotAlert);
